import React from "react";
import { Col } from "react-bootstrap";
import {
  SecurityEmailConfirmField,
  SecurityEmailField,
  SecurityPasswordConfirmField,
  SecurityPasswordField,
  SecurityPhoneConfirmField,
  SecurityPhoneField,
} from "./widget/SettingsPersonalSecurityTextFields";

const SettingsPersonalSecurityContent = (props: {
  type: number;
  name: string;
}) => {
  return (
    <form autoComplete="off">
      <Col xs={12} lg={6} className="mx-auto pt-5">
        {props.name === "password" ? (
          <>
            <SecurityPasswordField />
            <SecurityPasswordConfirmField />
          </>
        ) : props.name === "email" ? (
          <>
            <SecurityEmailField />
            <SecurityEmailConfirmField />
          </>
        ) : (
          <>
            <SecurityPhoneField />
            <SecurityPhoneConfirmField />
          </>
        )}
      </Col>
    </form>
  );
};

export default SettingsPersonalSecurityContent;
